// src/com/arrive_charge_info/ArriveChargeInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * ARRIVE_CHARGE_INFO Apollo Graphql
 * DC에서 도착지까지 운임정보
 * Project: NewTOP for cloud
 * 2026-04-29 16:47:13 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

/*

extend type Query {
	arriveChargeInfoList(arriveId:String!, vehTypeId:String!): [ArriveChargeInfo]!
	arriveChargeInfoItem(arriveId:String!, vehTypeId:String!): ArriveChargeInfo
}

extend type Mutation {
	arriveChargeInfoAdd(arriveChargeInfo: InputArriveChargeInfoAdd!): CommonResponse!
	arriveChargeInfoEdit(arriveChargeInfo: InputArriveChargeInfoEdit!): CommonResponse!
	arriveChargeInfoRemove(arriveChargeInfo: InputArriveChargeInfoRemove!): CommonResponse!
    arriveChargeInfoUpload(arriveChargeInfo: [InputArriveChargeInfoEdit]!): ResponseWithArriveChargeInfoResList!
    arriveChargeInfoSetUsage(arriveChargeInfo: InputArriveChargeInfoSetUsage!): CommonResponse!
}

*/
const ARRIVE_CHARGE_INFO_LIST_PART = gql`
fragment ArriveChargeInfoListPart on ArriveChargeInfo {
    arriveId
    vehTypeId
    vehTypeName
    charge
    addCharge
    useYn
    regTypeCd
    updateDate
    updateUser
    regDate
    regUser
    regUserName
}
`;

export const LIST_ARRIVE_CHARGE_INFO = gql`
${ARRIVE_CHARGE_INFO_LIST_PART}
query ListArriveChargeInfo($arriveId:String!) {
    arriveChargeInfoList(arriveId:$arriveId) {
        ...ArriveChargeInfoListPart
    }
}
`;

export const GET_ARRIVE_CHARGE_INFO = gql`
${ARRIVE_CHARGE_INFO_LIST_PART}
query GetArriveChargeInfo($arriveId:String!, $vehTypeId:String!) {
    arriveChargeInfoItem(arriveId:$arriveId, vehTypeId:$vehTypeId) {
        ...ArriveChargeInfoListPart
    }
}
`;

export const ADD_ARRIVE_CHARGE_INFO = gql`
mutation AddArriveChargeInfo($arriveChargeInfo:InputArriveChargeInfoAdd!) {
	arriveChargeInfoAdd(arriveChargeInfo: $arriveChargeInfo) {
		ok
		message
	}
}
`;

export const EDIT_ARRIVE_CHARGE_INFO = gql`
mutation EditArriveChargeInfo($arriveChargeInfo:InputArriveChargeInfoEdit!) {
	arriveChargeInfoEdit(arriveChargeInfo: $arriveChargeInfo) {
		ok
		message
	}
}
`;

export const REMOVE_ARRIVE_CHARGE_INFO = gql`
mutation RemoveArriveChargeInfo($arriveChargeInfo:InputArriveChargeInfoRemove!) {
	arriveChargeInfoRemove(arriveChargeInfo: $arriveChargeInfo) {
		ok
		message
	}
}
`;

// arriveChargeInfoUpload(arriveChargeInfo: [InputArriveChargeInfoEdit]!): CommonResponse!
export const UPLOAD_ARRIVE_CHARGE_INFO = gql`
mutation UploadArriveChargeInfo($arriveChargeInfo: [InputArriveChargeInfoEdit]!) {
    arriveChargeInfoUpload(arriveChargeInfo: $arriveChargeInfo) {
        ok
        message
        list {
            ok
            message
            arriveId
            vehTypeId
        }
    }
}
`;

// arriveChargeInfoSetUsage(arriveChargeInfo: InputArriveChargeInfoSetUsage!): CommonResponse!
export const SET_USAGE_ARRIVE_CHARGE_INFO = gql`
mutation SetUsageArriveChargeInfo($arriveChargeInfo: InputArriveChargeInfoSetUsage!) {
    arriveChargeInfoSetUsage(arriveChargeInfo: $arriveChargeInfo) {
        ok
        message
    }
}
`;
